import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({ blog }) {
  return (
    <div className="w-full md:w-1/2 xl:w-1/3 flex flex-col max-w-[400px] items-center justify-center blog-container mb-[30px] px-[15px]">
      <Link to={`/blogs/${blog.handle}`} className="w-full">
        <div className="inline-block w-full relative rounded-sm mb-[10px] cursor-pointer group">
          <img
            src={blog.imgUrl}
            alt={blog.imgAlt}
            title={blog.imgTitle}
            className="inline-block min-w-[350px] object-cover rounded-sm w-full h-[200px]"
          />
          <div className="absolute inset-0 bg-black/0 opacity-0 transition"></div>
        </div>

        {/* ✅ Use blog.text or meta_title as needed */}
        <h3 className="my-0 md:my-[10px] text-center md:text-left hover:text-[#cd2122] text-base italic leading-[1.4] cursor-pointer font-open">
          {blog.text || blog.meta_title}
        </h3>

        {blog.author && (
          <p className="text-sm text-gray-600 text-center md:text-left">
            By{" "}
            <Link
              to={`/author/${blog.author.toLowerCase()}`}
              className="hover:underline hover:text-[#DA2128]"
            >
              {blog.author}
            </Link>
          </p>
        )}
      </Link>
    </div>
  );
}
